import React, {
  Fragment,
  useMemo,
  useEffect,
  useState,
  createRef,
  cloneElement,
  useCallback,
  forwardRef,
} from 'react';
import cn from 'classnames';

const hash = {
  get() {
    return window.location.hash;
  },
  clear() {
    window.location.hash = '';
  },
};

const BriefSteps = (
  {
    invalid,
    onNext,
    onPrevious,
    children,
    nextAction = 'Next question',
    submitAction = 'Next question',
    previousAction = 'Previous question',
  },
  ref,
) => {
  const [step, setStep] = useState(0);
  const [attemptedSubmission, setAttemptedSubmission] = useState(false);
  const allChildren = useMemo(() => children.filter(Boolean), [children]);
  const refs = useMemo(() => allChildren.map(() => createRef()), [allChildren.length]);

  const handleScroll = useCallback(
    newStep => {
      if (refs[newStep] && refs[newStep].current && !hash.get()) {
        refs[newStep].current.scrollIntoView({ behavior: 'smooth' });
      }
    },
    [refs],
  );

  useEffect(
    () => {
      const listener = () => {
        const height = window.innerHeight || document.documentElement.clientHeight;
        const gap = height / 3;
        const visibleRef = refs.find(r => {
          const offset = r && r.current && r.current.getBoundingClientRect().top;
          return offset >= -gap && offset <= gap;
        });
        if (visibleRef && visibleRef.current) {
          refs.forEach(r => r && r.current && r.current.classList.remove('-active'));
          visibleRef.current.classList.add('-active');
        }
      };
      window.addEventListener('scroll', listener, { passive: true });
      return () => {
        window.removeEventListener('scroll', listener);
      };
    },
    [refs, step],
  );

  useEffect(
    () => {
      handleScroll(step);
    },
    [step],
  );

  const handleNext = useCallback(
    newStep => {
      onNext();
      // hash.clear();
      // if (invalid[newStep]) {
      //   setStep(newStep);
      //   setAttemptedSubmission(true);
      // } else {
      //   setAttemptedSubmission(false);
      //
      //   if (newStep < allChildren.length - 1) {
      //     setStep(newStep + 1);
      //   } else {
      //     const firstInvalid = invalid.findIndex(Boolean);
      //     if (firstInvalid >= 0) {
      //       setStep(firstInvalid);
      //       setAttemptedSubmission(true);
      //
      //       if (refs[firstInvalid] && refs[firstInvalid].current) {
      //         refs[firstInvalid].current.scrollIntoView({ behavior: 'smooth' });
      //       }
      //     } else {
      //       onNext();
      //     }
      //   }
      // }
      //
      // if (step === newStep + 1) {
      //   handleScroll(newStep + 1);
      // }
    },
    [invalid, allChildren, step],
  );

  const handlePrevious = useCallback(
    newStep => {
      hash.clear();
      if (newStep > 0) {
        const stepToSet = newStep - 1;
        setStep(stepToSet);

        if (refs[stepToSet] && refs[stepToSet].current) {
          refs[stepToSet].current.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        onPrevious && onPrevious();
      }
    },
    [allChildren],
  );

  return (
    <div ref={ref} className="brief_steps">
      {children}
    </div>
  );
};

export default forwardRef(BriefSteps);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefSteps.js